import _ from 'underscore'
import $ from 'jquery'

const getQueryStringHash = function() {
  const terms = window.location.search.substr(1).split('&')
  let h = {}

  _.each(terms, function(term) {
    if (term !== '') {
      const parts = term.split('=')

      if (parts[1]) {
        h[parts[0]] = decodeURIComponent(parts[1].replace(/\+/g, " "))
      }
    }
  })

  return h
}

const updateLocation = function(params = {}) {
  let h = {
    protocol: window.location.protocol,
    host: window.location.host,
    pathname: window.location.pathname,
    search: getQueryStringHash()
  }

  h = _.extend(h, params)

  const newurl = (_.isEmpty(h.search)) ?
    h.protocol + "//" + h.host + h.pathname
  :
    h.protocol + "//" + h.host + h.pathname + `?${$.param(h.search)}`

  window.history.pushState({path: newurl}, '', newurl)
}

export { getQueryStringHash, updateLocation }